module.exports = __webpack_public_path__ + "static/img/icon1.7fce3ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/aboutUs/qualificationHonor/icon1.png
// module id = uLLQ
// module chunks = 1